import pkceChallenge from 'pkce-challenge'

export const getPkceChallenge = () => {
  return pkceChallenge()
}
